import i18n from '@/i18n';

const toToman = (
  price: string | number,
  options?: { labelLess?: boolean }
): string => {
  const { labelLess = false } = options || {};
  const separator = `${Number(price).toLocaleString()} ${labelLess ? '' : i18n.t('utils.toToman.toman')}`;
  return separator;
};

export default toToman;
